// © Microsoft Corporation. All rights reserved.

import { ActionMap } from "@msnews/experiences-redux";
import { PrimaryAccountInfo } from "./WindowsPageSettings.state";

export type MarketUpdated = (market: string) => void;
export type UpdatePrimaryAccountInfo = (accountInfo: PrimaryAccountInfo) => void;

/**
 * Exposes actions to update the state for the windows page settings data connector.
 */
export class WindowsPageSettingsActions {
    /** Action to trigger when the market setting has changed */
    public static marketUpdated = new ActionMap<MarketUpdated>("marketUpdated");

    /** Action to notify that primary account info was successfully loaded from the API. */
    public static updatePrimaryAccountInfo = new ActionMap<UpdatePrimaryAccountInfo>("updatePrimaryAccountInfo");
}